module.exports = __webpack_public_path__ + "assets/img/my3.44ea014e.png";